import React from 'react';
import HomeworkEditor from '../../components/Admin/HomeworkEditor';

const HomeworkPage = () => {
  return <HomeworkEditor />;
};

export default HomeworkPage;